import { createStyles, makeStyles, Theme } from "@material-ui/core";

interface LynxLinkStylesProps {
    size: "standard" | "small";
}

export const lynxLinkStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            color: theme.colors.primary.blue500,
            fontSize: ({ size }: LynxLinkStylesProps) =>
                size === "standard"
                    ? theme.typography.body1.fontSize
                    : theme.typography.body2.fontSize,
            lineHeight: ({ size }: LynxLinkStylesProps) =>
                size === "standard"
                    ? theme.typography.body1.lineHeight
                    : theme.typography.body2.lineHeight,
            fontWeight: 500,
        },
    })
);
